export default "assets/f8b6d6dcc70e202459718929d12a94cb.png";